import { render, staticRenderFns } from "./TwinMatter.vue?vue&type=template&id=b1c94fbc&scoped=true"
import script from "./TwinMatter.vue?vue&type=script&lang=js"
export * from "./TwinMatter.vue?vue&type=script&lang=js"
import style0 from "./TwinMatter.vue?vue&type=style&index=0&id=b1c94fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c94fbc",
  null
  
)

export default component.exports